"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('table', {
      staticClass: "z-table",
      class: {
        'z-table-bordered': _vm.fullBordered,
        'z-table-no-cell-bordered': !_vm.cellBordered,
        'z-table-no-content-bordered': !_vm.contentBordered
      }
    }, [_vm._t("default")], 2);
  },
  name: 'z-table',
  props: {
    fullBordered: Boolean,
    cellBordered: {
      type: Boolean,
      default: true
    },
    contentBordered: {
      type: Boolean,
      default: true
    }
  }
};
exports.default = _default;